import Menu from "./Menu.vue";

export default Menu;